module.exports = __webpack_public_path__ + "static/media/stepsToInstall.35e4ddcd.png";